import httper from '../../common/httper.js'
import Qs from 'Qs'
const http = httper.create('/wx-api/pc')

export default {
  login: (data) => http.post('/delivery/accountLogin', Qs.stringify(data)),
}



// WEBPACK FOOTER //
// ./src/services/login/api.js